import React, { Component, Fragment } from 'react'
import { observer, inject } from 'mobx-react'
import { BrowserRouter as Router, Switch, Redirect } from 'react-router-dom'
import Loadable from 'react-loadable'
import {
  localStrings,
  forceSetLanguage,
  getLanguage,
  routeInit,
  languageRouteInit
} from '@/utils/localization'

import AppliedRoute from './components/AppliedRoute'
import HomeRoute from './components/HomeRoute'
import ProtectedRoute from './components/ProtectedRoute'
import FasooProtectedRoute from './components/FasooProtectedRoute'
import LoadingComponent from './components/LoadingComponent'

const AsyncHome = Loadable({
  loader: () => import('./containers/Login'),
  loading: LoadingComponent
})
const AsyncClose = Loadable({
  loader: () => import('./components/Common/close'),
  loading: LoadingComponent
})

const AsyncLogin = Loadable({
  loader: () => import('./containers/Login'),
  loading: LoadingComponent
})

const AsyncFasooLogin = Loadable({
  loader: () => import('./containers/FasooLogin'),
  loading: LoadingComponent
})

const AsyncJoin = Loadable({
  loader: () => import('./containers/Join'),
  loading: LoadingComponent
})

const AsyncConsole = Loadable({
  loader: () => import('./containers/Console'),
  loading: LoadingComponent
})

const AsyncMyAccount = Loadable({
  loader: () => import('./containers/Console/MyAccount'),
  loading: LoadingComponent
})

const AsyncBill = Loadable({
  loader: () => import('./containers/Console/Bill'),
  loading: LoadingComponent
})

const AsyncBillStatement = Loadable({
  loader: () => import('./containers/Console/Bill/Statement'),
  loading: LoadingComponent
})

const SiteType = Loadable({
  loader: () => import('./containers/Console/Site/Type'),
  loading: LoadingComponent
})

const SiteTrial = Loadable({
  loader: () => import('./containers/Console/Site/Trial'),
  loading: LoadingComponent
})

const SitePay = Loadable({
  loader: () => import('./containers/Console/Site/Pay'),
  loading: LoadingComponent
})

const SitePromotion = Loadable({
  loader: () => import('./containers/Console/Site/Promotion'),
  loading: LoadingComponent
})

const SiteNew = Loadable({
  loader: () => import('./containers/Console/Site/New'),
  loading: LoadingComponent
})

const notFoundError = Loadable({
  loader: () => import('./containers/Error'),
  loading: LoadingComponent
})

const AsyncFasooConsole = Loadable({
  loader: () => import('./containers/FasooConsole'),
  loading: LoadingComponent
})

const AsyncFasooSite = Loadable({
  loader: () => import('./containers/FasooConsole/Site'),
  loading: LoadingComponent
})

const AsyncFasooLicense = Loadable({
  loader: () => import('./containers/FasooConsole/License'),
  loading: LoadingComponent
})

const AsyncFasooBill = Loadable({
  loader: () => import('./containers/FasooConsole/Bill'),
  loading: LoadingComponent
})

const AsyncFasooCoupon = Loadable({
  loader: () => import('./containers/FasooConsole/Coupon'),
  loading: LoadingComponent
})

const AsyncFasooTrial = Loadable({
  loader: () => import('./containers/FasooConsole/Trial'),
  loading: LoadingComponent
})

const AsyncFasooNotice = Loadable({
  loader: () => import('./containers/FasooConsole/Notice'),
  loading: LoadingComponent
})

const AsyncFasooUser = Loadable({
  loader: () => import('./containers/FasooConsole/User'),
  loading: LoadingComponent
})

const AsyncFasooAdminUser = Loadable({
  loader: () => import('./containers/FasooConsole/AdminUser'),
  loading: LoadingComponent
})

const AsyncFasooDtoStat = Loadable({
  loader: () => import('./containers/FasooConsole/FasooDtoStat'),
  loading: LoadingComponent
})

const AsyncFasooQnA = Loadable({
  loader: () => import('./containers/FasooConsole/QnA'),
  loading: LoadingComponent
})

const AsyncFasooUpc = Loadable({
  loader: () => import('./containers/FasooConsole/UPC'),
  loading: LoadingComponent
})

@inject('store')
@observer
export default class RouterContainer extends Component {
  // state = {
  //   lang: getLanguage()
  // }
  componentWillMount = () => {
    languageRouteInit()
    const defaultLang = forceSetLanguage()
    localStrings.setLanguage(defaultLang)

    // this.lang = getLanguage()
    let querystring = window.location.search.substr(1).split('?')
    let params

    if (querystring !== '') {
      params = new URLSearchParams(querystring[0])
    }

    if (params.has('resultMsg')) {
      alert(params.get('resultMsg'))
    }
  }

  render() {
    return (
      <Router>
        <Switch>
          <AppliedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/`}
            component={AsyncHome}
            props={this.props}
          />
          <AppliedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/close`}
            component={AsyncClose}
            props={this.props}
          />
          <AppliedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/join`}
            component={AsyncJoin}
            props={this.props}
          />
          <AppliedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/login`}
            component={AsyncLogin}
            props={this.props}
          />
          <ProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/console`}
            component={AsyncConsole}
            props={this.props}
          />
          <ProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/my-account`}
            component={AsyncMyAccount}
            props={this.props}
          />
          <ProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/bill`}
            component={AsyncBill}
            props={this.props}
          />
          <ProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/bill/statement/:id`}
            component={AsyncBillStatement}
            props={this.props}
          />
          <ProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/site/type`}
            component={SiteType}
            props={this.props}
          />
          <ProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/site/trial`}
            component={SiteTrial}
            props={this.props}
          />
          <ProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/site/pay`}
            component={SitePay}
            props={this.props}
          />
          <ProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/site/promotion`}
            component={SitePromotion}
            props={this.props}
          />
          <ProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/site/new`}
            component={SiteNew}
            props={this.props}
          />
          <AppliedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/error`}
            component={notFoundError}
            props={this.props}
          />
          <AppliedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasooLogin`}
            component={AsyncFasooLogin}
            props={this.props}
          />
          <FasooProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasoo/console`}
            component={AsyncFasooConsole}
            props={this.props}
          />
          <FasooProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasoo/site`}
            component={AsyncFasooSite}
            props={this.props}
          />
          <FasooProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasoo/license`}
            component={AsyncFasooLicense}
            props={this.props}
          />
          <FasooProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasoo/bill`}
            component={AsyncFasooBill}
            props={this.props}
          />
          <FasooProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasoo/coupon`}
            component={AsyncFasooCoupon}
            props={this.props}
          />
          <FasooProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasoo/trial`}
            component={AsyncFasooTrial}
            props={this.props}
          />
          <FasooProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasoo/notice`}
            component={AsyncFasooNotice}
            props={this.props}
          />
          <FasooProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasoo/user`}
            component={AsyncFasooUser}
            props={this.props}
          />
          <FasooProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasoo/adminUser`}
            component={AsyncFasooAdminUser}
            props={this.props}
          />
          <FasooProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasoo/fasooDtoStat`}
            component={AsyncFasooDtoStat}
            props={this.props}
          />
          <FasooProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasoo/qna`}
            component={AsyncFasooQnA}
            props={this.props}
          />
          <FasooProtectedRoute
            exact
            path={`${process.env.PUBLIC_URL}/:lang/fasoo/upc`}
            component={AsyncFasooUpc}
            props={this.props}
          />
          <AppliedRoute component={notFoundError} />
        </Switch>
      </Router>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Routes.js